import SortingLinks from './SortingLinks';

export default SortingLinks;
